export default __webpack_public_path__ + "static/media/Capacity.9ec9d83a.svg";